import axios from '@/services/axios.js'
import { getHeadersWithAccessToken } from '@/auth/tokenService'
import baseURLs from '@/api/APIBaseURLs'

export function getDatasets () {
  const url = baseURLs.tsqlAPI + '/analytics'
  return axios.get(url, {
    headers: getHeadersWithAccessToken()
  }).then(({ data }) => data)
}

export function getDashboards () {
  const url = baseURLs.manageAPI + '/analytics_dashboard'
  return axios.get(url, {
    headers: getHeadersWithAccessToken()
  }).then(({ data }) => data)
    .catch(e => {
      console.error('getDashboards error:', e)
      return { dashboards: [], dashboards_shared: [], dashboards_public: [] }
    })
}

export function getViewsCopy () {
  const url = baseURLs.manageAPI + '/analytics_views_copy'
  return axios.get(url, {
    headers: getHeadersWithAccessToken()
  }).then(({ data: { views } }) => views)
    .catch(e => console.log(e))
}

export function getViewDetails (viewKey) {
  const url = baseURLs.manageAPI + '/analytics_view?view_key=' + viewKey
  return axios.get(url, {
    headers: getHeadersWithAccessToken()
  }).then(({ data: { view } }) => view)
    .catch(e => console.log(e))
}

export function getDashboardDetails (chosenDashboard) {
  const url = baseURLs.manageAPI + '/analytics_dashboard?dashboard_key=' + chosenDashboard
  return axios.get(url, {
    headers: getHeadersWithAccessToken()
  }).then(({ data}) => data)
}

export function getDashboardManage () {
  const url = baseURLs.manageAPI + '/analytics_dashboards_manage'
  return axios.get(url, {
    headers: getHeadersWithAccessToken()
  }).then(({ data: { dashboards } }) => dashboards)
    .catch(e => console.log(e))
}

export async function loadViewData (payload, view, totals, expanded) {
  const url = baseURLs.tsqlAPI + '/analytics'
  return axios.post(url, payload)
    .then(({ data }) => {
      view.limited = data.limited
      view.filters_applied = data.filters_applied
      view.refresh_time_ago = data.refresh_time_ago
      if(payload.chart_type === 'table' && payload.properties.matrix){
        return performMatrixData(data, totals, view, expanded)
      }
      if(payload.total && data.total){
        totals.total_row = [data.total]
      }
      return payload.format === 'doa' ? performTableData(data.data, view) : data.data
    })
}

export async function downloadAnalytics (payload, child = false) {
  const url = baseURLs.tsqlAPI + '/analytics'
  payload = await performViewData(payload, false, payload.filters, true, child)
  return axios.post(
    url,
    payload)
    .then(({ data }) => {
      return data
    })
}

function performTableData (data, view) {
  const newData = []
  const keys = Object.keys(data)
  data[keys[0]].forEach((item, index) => {
    const newObject = {}
    keys.forEach((key) => {
      newObject[key] = data[key][index]
    })
    if(view?.properties?.child_rows){
      newObject.hasChildren = true
    }
    newData.push(newObject)
  })
  return newData
}


const performMatrixData = (data, totals, view, expanded)=> {
  if(expanded){
    if(view.properties.total_column){
      totals.total_column = performTableData(data.data[1].data, view)
    }
  }else if(view.properties.total_column && view.properties.total_row){
    totals.total_column = performTableData(data.data[1].data, view)
    totals.total_row = performTableData(data.data[2].data, view)
    totals.totals_sum = performTableData(data.data[3].data, view)
  }else if(view.properties.total_row){
    totals.total_row = performTableData(data.data[1].data, view)
  }else if(view.properties.total_column){
    totals.total_column = performTableData(data.data[1].data, view)
  }
  return performTableData(data.data[0].data, view)
}
const getMatrixPayload = (payload, expanded = false)=> {
  const rowsDimensions = [ payload.properties.matrix, ...payload.dimensions]
  const dimensions = [rowsDimensions]
  if(payload.properties.total_column){
    dimensions.push(payload.dimensions)
  }
  if(!expanded && payload.properties.total_row){
    dimensions.push([payload.properties.matrix])
  }
  if(!expanded && payload.properties.total_column && payload.properties.total_row){
    dimensions.push([])
  }
  payload.dimensions = dimensions
}

const getTablePayload = (payload, expanded)=> {
  payload.format = 'doa'
  if (expanded) {
    if (payload.properties.child_limit) {
      payload.properties.limit = parseInt(payload.properties.child_limit)
    }
    if(payload.properties.matrix){
      getMatrixPayload(payload, true)
    }
  } else {
    payload.properties.limit = parseInt(payload.properties.parent_limit)
    if(payload.properties.matrix){
      getMatrixPayload(payload)
    }else if(payload.properties.total_row){
      payload.total = true
    }

  }

}

const getAnalyticsPayload = (view, expanded = false, additionalFilters = {})=> {
  if (!view.filters) {
    view.filters = {}
  }

  if (!view.properties) {
    view.properties = { }
  }
  const payload = { ...view, properties: { ...view.properties } }
  payload.measures = payload.measures.filter(item => item.calculation)
  payload.dimensions = view.dimensions ? [...view.dimensions] : []
  if(payload.chart_type === 'table') {
    getTablePayload(payload, expanded)
  }else {
    payload.properties.limit = parseInt(payload.properties.parent_limit)
  }
  if (payload.chart_type !== 'table' && payload.chart_type !== 'bar_chart') {
    delete payload.properties.sort
    delete payload.properties.sort_order
  }
  payload.filters = {...(additionalFilters || {}), ...payload.filters }
  if(payload.chart_type === 'doughnut_chart'){
    payload.properties.sort = payload.measures[0].name
    payload.properties.sort_order = 'ascending'
    payload.total = true
  }
  return payload
}

export async function performViewData (view, expanded = false, additionalFilters = {}, needForDownload = false, downloadForChild = false) {
  const payload = getAnalyticsPayload(view, expanded, additionalFilters)
  if (needForDownload) {
    if (downloadForChild) {
      payload.dimensions = [...view.dimensions, view.properties.child_rows]
      if(payload.properties.matrix) {
        payload.dimensions.push(payload.properties.matrix)
      }
      delete payload.limit
    }else {
      if(payload.properties.matrix) {
        payload.dimensions = [payload.properties.matrix, ...view.dimensions]
      }else {
        payload.dimensions = view.dimensions
      }
    }
    return payload
  }

  let data
  const totals = {total_row: null, total_column: null, totals_sum: null}
  try {
    await loadViewData({...payload}, view, totals, expanded).then(res => {
      if (expanded) {
        payload.measuresProps = payload.measures.reduce((prev, cur) => {
          let name = cur.name
          let count = 1
          while(prev[name]){
            count++
            name = `${cur.name} (${count})`
          }
          prev[name] = cur
          return prev
        }, {})
        view.childViews = {
          view: payload,
          data: res,
        }
        data = { ...view }
        return
      }
      view.measuresProps = view.measures.reduce((prev, cur) => {
        let name = cur.name
        let count = 1
        while(prev[name]){
          count++
          name = `${cur.name} (${count})`
        }
        prev[name] = cur
        return prev
      }, {})
      data =  { view, data: res }
    })
    // Once everything is resolved we can set totals to data
    if (expanded) {
      data.childViews.total_row = totals.total_row
      data.childViews.total_column = totals.total_column
      return data
    }
    return { ...data, ...totals }
  } catch (e) {
    console.error(e)
    return { view, errored: true }
  }
}

export function loadFilterProperties (dataset) {
  const url = baseURLs.tsqlAPI + '/analytics_properties'
  const dataSets = dataset === 'none' ? {} : { dataset }
  return axios.post(
    url,
    dataSets)
    .then(({ data }) => data)
    .catch((error) => {
      console.log(error)
      return {}
    })
}

export function saveDashboard (payload) {
  const url = baseURLs.manageAPI + '/analytics_dashboard'

  return axios.post(
    url,
    payload)
    .catch(e => console.log(e))
}

export function duplicateDashboard (payload) {
  const url = baseURLs.manageAPI + '/analytics_dashboards_manage'

  return axios.post(
    url,
    payload)
    .catch(e => console.log(e))
}

export function deleteDashboard (payload) {
  const url = baseURLs.manageAPI + '/analytics_dashboard'

  return axios.delete(
    url,
    {
      headers: getHeadersWithAccessToken(),
      data: payload,
    })
    .catch(e => console.log(e))
}

export function saveView (payload) {
  const url = baseURLs.manageAPI + '/analytics_view'
  payload.dashboard_key = parseInt(payload.dashboard_key)
  return axios.post(
    url,
    payload)
    .then(({ data: { view } }) => view)
    .catch(e => e)
}

export function setDashboardName (payload) {
  const url = baseURLs.manageAPI + '/analytics_dashboard'
  return axios.post(
    url,
    payload)
}
